import FullWidthWrapper from './fullWidthWrapper.js';
export default FullWidthWrapper;
